import { Button, Modal, Text } from "@marketplace/ui";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { deleteSalesModalAtom } from "../../atoms";
import { useDeleteSalesMutation } from "../../hooks/mutations/use-delete-sales-mutation";

export const DeleteSalesModal = () => {
  const { t } = useTranslation("users");
  const { visible, data } = useAtomValue(deleteSalesModalAtom);
  const resetDeleteSalesModal = useResetAtom(deleteSalesModalAtom);
  const { mutate: deleteSales, isPending } = useDeleteSalesMutation();

  const handleDelete = () => {
    if (data?.id) {
      deleteSales(
        { salesId: data.id },
        {
          onSuccess: () => {
            resetDeleteSalesModal();
          }
        }
      );
    }
  };

  return (
    <Modal
      opened={visible}
      onClose={resetDeleteSalesModal}
      title={<Text type="heading">{t("salesListPage.deleteModal.title")}</Text>}
      size={400}
      withCloseButton={false}
      classNames={{
        header: "!pt-6 !pb-0 !min-h-fit",
        body: "!p-6"
      }}
    >
      <Text type="paragraph" className="text-center mb-6">
        {t("salesListPage.deleteModal.description")}
      </Text>

      <div className="flex gap-x-[14px]">
        <Button fullWidth variant="secondary" onClick={resetDeleteSalesModal}>
          {t("salesListPage.deleteModal.button.cancel")}
        </Button>
        <Button
          fullWidth
          variant="primary"
          onClick={handleDelete}
          loading={isPending}
        >
          {t("salesListPage.deleteModal.button.delete")}
        </Button>
      </div>
    </Modal>
  );
};
